import snq from 'snq';
import { trim } from 'lodash';
import i18n from '../../../../utils/i18n';

export function getBetDescription({ betObject, line }) {
  const description = betObject.GameDescription;
  const identifler = '@_';
  const regExp = /\@_(.*)\~/;
  let between = snq(() => regExp.exec(description)[1]);

  if (between) {
    between = trim(between.replace('~', ''));
    return {
      selection: snq(() => trim(between)),
      game: snq(() => trim(description.split(identifler)[0])),
      market: snq(() => trim(description.split('~')[1])),
    };
  } else {
    return {
      selection: ['ml', 'sp', 'to'].includes(line) ? i18n.t('BetSlip.Full Time') : '',
      game: snq(() => trim(description.split('~')[0])),
      market: snq(() => trim(description.split('~')[1])),
    };
  }
}
